import { ProductModel } from "@/types/product";
import React from "react";
import ProductCard from "./product-card";
import { useTranslations } from "next-intl";
import AppEmpty from "../ui/app-empty";
import { PackageXIcon } from "lucide-react";
import AnimatedElement from "../ui/animated-element";

const ProductsGrid = ({
  products,
  emptyText,
}: {
  products: ProductModel[];
  emptyText?: string;
}) => {
  const t = useTranslations();
  return products?.length === 0 ? (
    <AppEmpty
      title={t("noProducts")}
      description={emptyText ?? t("noProductsFound")}
      icon={<PackageXIcon />}
    />
  ) : (
    <AnimatedElement
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        ease: "easeInOut",
        duration: 0.5,
      }}
      className="grid grid-cols-2 xl:grid-cols-4 gap-5"
    >
      {products?.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </AnimatedElement>
  );
};

export default ProductsGrid;
